import axios from "axios";
import JsCookie from "js-cookie";
var instance = axios.create({
  withCredentials: true,
  headers: {
    "X-CSRFToken": JsCookie.get("csrftoken")
  }
});
export default instance;